import { useEffect, useRef } from "react";

const AutoMuteVideo = ({ src, rootMarging }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      },
      {
        threshold: 0, // 60% of video visible
      }
    );
    if (video) observer.observe(video);
    return () => {
      if (video) observer.unobserve(video);
    };
  }, []);

  return (
    <video
      ref={videoRef}
      src={src}
      muted
      autoPlay
      loop
      playsInline
      width="100%"
    />
  );
};

export default AutoMuteVideo;
